/* Demo content for the mobile wedding invitation template. */

export const couple = {
  groom: {
    name: '김도윤',
    role: 'Groom',
    parents: '김정호 · 박선영 의 장남',
    phone: '010-4829-3716',
  },
  bride: {
    name: '이서연',
    role: 'Bride',
    parents: '이광수 · 최은자 의 장녀',
    phone: '010-5517-9024',
  },
  weddingDate: '2026년 5월 16일 토요일',
  weddingTime: '오후 1시 00분',
  dateShort: '2026. 05. 16',
};

export const venue = {
  name: '그랜드 하우스 서울',
  hall: '3층 그랜드홀',
  address: '서울특별시 강남구 테헤란로 152',
  addressDetail: '그랜드 하우스 서울 (역삼동 737)',
  mapEmbed:
    'https://www.google.com/maps?q=Seoul%20Gangnam-gu%20Teheran-ro%20152&hl=ko&z=15&output=embed',
  mapLink: 'https://www.google.com/maps?q=Seoul%20Gangnam-gu%20Teheran-ro%20152',
};

export const heroBeats = {
  beat1: {
    stamp: '01 — 초대',
    headline: '우리의 가장 빛나는 날에<br>당신을 <em class="accent">모십니다</em>',
    sub: '두 사람이 오래도록 기다려 온 봄의 약속. 그 자리에 함께해 주세요.',
  },
  beat2: {
    stamp: '02 — 예식',
    headline: '2026년 5월 16일,<br>봄 한가운데서',
    sub: '서울 강남 그랜드 하우스 3층 그랜드홀에서 뵙겠습니다.',
  },
  chips: ['오후 1시 예식', '그랜드 하우스 3F', '주차 2시간 무료'],
};

export const greeting = {
  text: '서로의 가장 좋은 계절이 되어, 같은 곳을 바라보며 천천히 걷겠습니다. 두 사람의 시작을 따뜻하게 지켜봐 주세요.',
  sign: '도윤 그리고 서연',
};

export const ceremonyInfo = [
  { label: '날짜', value: '2026년 5월 16일 토요일' },
  { label: '시간', value: '오후 1시 00분 (본식) · 오후 12시 30분 입장' },
  { label: '예식장', value: '그랜드 하우스 서울 3층 그랜드홀' },
  { label: '주소', value: '서울특별시 강남구 테헤란로 152' },
  { label: '주차', value: '건물 지하 1~3층 · 예식 2시간 무료' },
  { label: '대중교통', value: '2호선 역삼역 3번 출구 도보 5분' },
];

export const transportInfo = [
  { label: '지하철', value: '2호선 역삼역 3번 출구에서 도보 5분\n신분당선 강남역 4번 출구에서 도보 12분' },
  { label: '버스', value: '역삼역 정류장 하차\n간선 140 · 340 · 402 / 지선 4212' },
  { label: '자차', value: '내비게이션에 "그랜드 하우스 서울" 검색\n건물 지하 주차장 이용 (2시간 무료)' },
];

export const accounts = [
  {
    side: '신랑 측',
    bank: '신한은행',
    number: '110-482-937165',
    holder: '김정호',
  },
  {
    side: '신부 측',
    bank: '국민은행',
    number: '802-24-0153742',
    holder: '이광수',
  },
];

export const galleryImages = [
  { id: 1, src: 'https://readdy.ai/api/search-image?query=Elegant%20bride%20portrait%20in%20a%20flowing%20ivory%20gown%20holding%20a%20cream%20rose%20bouquet%2C%20warm%20cinematic%20light%2C%20soft%20dark%20interior%20background%2C%20editorial%20wedding%20photography%2C%20muted%20warm%20brown%20tones&width=800&height=1000&seq=wed-gal-01&orientation=portrait', alt: '신부 단독 웨딩 사진' },
  { id: 2, src: 'https://readdy.ai/api/search-image?query=Handsome%20groom%20portrait%20in%20a%20classic%20black%20tuxedo%20with%20boutonniere%2C%20warm%20golden%20light%2C%20blurred%20elegant%20hall%20background%2C%20cinematic%20wedding%20photography%2C%20warm%20brown%20tones&width=800&height=1000&seq=wed-gal-02&orientation=portrait', alt: '신랑 단독 웨딩 사진' },
  { id: 3, src: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20bride%20and%20groom%20hands%20with%20wedding%20rings%2C%20soft%20warm%20light%2C%20dark%20muted%20background%2C%20romantic%20cinematic%20detail%20photography&width=800&height=1000&seq=wed-gal-03&orientation=portrait', alt: '결혼 반지와 두 사람의 손' },
  { id: 4, src: 'https://readdy.ai/api/search-image?query=Bridal%20bouquet%20of%20cream%20roses%20and%20dried%20eucalyptus%20resting%20on%20a%20dark%20walnut%20table%2C%20warm%20cinematic%20still%20life%2C%20soft%20shadows%20and%20muted%20tones&width=800&height=1000&seq=wed-gal-04&orientation=portrait', alt: '웨딩 부케 클로즈업' },
  { id: 5, src: 'https://readdy.ai/api/search-image?query=Bride%20walking%20down%20a%20ceremony%20aisle%20lined%20with%20candles%20and%20white%20flowers%2C%20warm%20ambient%20light%2C%20cinematic%20wide%20wedding%20photography%2C%20muted%20warm%20tones&width=800&height=1000&seq=wed-gal-05&orientation=portrait', alt: '버진로드 입장' },
  { id: 6, src: 'https://readdy.ai/api/search-image?query=Couple%20sharing%20a%20quiet%20first%20look%20moment%20in%20a%20sunlit%20corridor%2C%20warm%20backlight%2C%20soft%20focus%2C%20cinematic%20romantic%20wedding%20photography&width=800&height=1000&seq=wed-gal-06&orientation=portrait', alt: '첫 만남의 순간' },
  { id: 7, src: 'https://readdy.ai/api/search-image?query=Bride%20and%20groom%20laughing%20together%20during%20the%20reception%20toast%2C%20warm%20candlelight%2C%20blurred%20elegant%20dining%20hall%2C%20cinematic%20wedding%20photography&width=800&height=1000&seq=wed-gal-07&orientation=portrait', alt: '피로연의 두 사람' },
  { id: 8, src: 'https://readdy.ai/api/search-image?query=Delicate%20lace%20veil%20detail%20on%20an%20ivory%20wedding%20dress%2C%20soft%20window%20light%2C%20warm%20muted%20tones%2C%20cinematic%20editorial%20close%20up&width=800&height=1000&seq=wed-gal-08&orientation=portrait', alt: '드레스 디테일' },
  { id: 9, src: 'https://readdy.ai/api/search-image?query=Elegant%20wedding%20reception%20table%20setting%20with%20candles%20and%20cream%20flowers%2C%20warm%20dim%20lighting%2C%20moody%20cinematic%20photography%2C%20muted%20brown%20tones&width=800&height=1000&seq=wed-gal-09&orientation=portrait', alt: '피로연 테이블 세팅' },
  { id: 10, src: 'https://readdy.ai/api/search-image?query=Bride%20and%20groom%20walking%20hand%20in%20hand%20at%20golden%20hour%2C%20warm%20sun%20flare%2C%20silhouette%20of%20trees%2C%20romantic%20cinematic%20wedding%20photography&width=800&height=1000&seq=wed-gal-10&orientation=portrait', alt: '골든아워 산책' },
  { id: 11, src: 'https://readdy.ai/api/search-image?query=First%20dance%20of%20the%20bride%20and%20groom%20under%20warm%20string%20lights%2C%20blurred%20guests%20in%20the%20background%2C%20cinematic%20wedding%20photography%2C%20muted%20warm%20tones&width=800&height=1000&seq=wed-gal-11&orientation=portrait', alt: '첫 춤' },
  { id: 12, src: 'https://readdy.ai/api/search-image?query=Bride%20and%20groom%20holding%20a%20stack%20of%20printed%20wedding%20photographs%20on%20a%20wooden%20table%2C%20warm%20top%20light%2C%20nostalgic%20cinematic%20mood%2C%20muted%20brown%20tones&width=800&height=1000&seq=wed-gal-12&orientation=portrait', alt: '웨딩 사진을 든 두 사람' },
];

export const guestbookSeed = [
  {
    id: 'g1',
    name: '박지훈',
    side: '신랑 측',
    message: '도윤아 드디어 결혼하는구나! 두 사람 앞날에 행복이 가득하길 바랄게. 축하해!',
    date: '2026. 05. 01',
  },
  {
    id: 'g2',
    name: '최유진',
    side: '신부 측',
    message: '서연아, 너의 가장 빛나는 날에 함께할 수 있어서 정말 기뻐. 오래오래 행복하자.',
    date: '2026. 05. 02',
  },
  {
    id: 'g3',
    name: '정민수',
    side: '신랑 측',
    message: '멋진 신랑 신부의 앞날을 진심으로 축하합니다. 좋은 날 뵙겠습니다!',
    date: '2026. 05. 03',
  },
  {
    id: 'g4',
    name: '한소영',
    side: '신부 측',
    message: '두 분의 봄날을 축복합니다. 따뜻한 가정 이루시길 바라요.',
    date: '2026. 05. 04',
  },
  {
    id: 'g5',
    name: '오세영',
    side: '신랑 측',
    message: '먼 곳에서도 마음으로 함께합니다. 행복한 결혼 생활 되세요.',
    date: '2026. 05. 05',
  },
];

export const extraInfo = [
  {
    title: '식사 안내',
    items: [
      '예식 후 3층 연회장에서 뷔페로 진행됩니다.',
      '오후 12시 30분부터 입장 가능합니다.',
      '식이 제한이 있으신 분은 미리 알려 주세요.',
    ],
  },
  {
    title: '답례품 · 셔틀',
    items: [
      '답례품은 연회장 입구에서 전달해 드립니다.',
      '강남역 4번 출구에서 30분 간격 셔틀 운행.',
      '셔틀 막차는 오후 5시 30분입니다.',
    ],
  },
  {
    title: '유의 사항',
    items: [
      '주차는 2시간까지 무료, 이후 10분당 1,000원.',
      '화환은 정중히 사양합니다.',
      '예식 중에는 휴대폰을 무음으로 부탁드립니다.',
    ],
  },
];